export default __webpack_public_path__ + "static/media/laptop.7248eff5.webp";